import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Col, Container, Row, Table, TabContent, TabPane } from 'reactstrap';
import Loading from '../../../shared/components/custom/Loading';
import Api from '../../../util/api';
import t from '../../../util/translation/translation';
import { formatDate } from '../../../util/date-and-time';
import NavTab from '../../../shared/components/custom/NavTab';
import ExternalTickets from './tickets/ExternalTickets';

const UserTicketsPage = ({ userID, phoneNumber }) => {
  const [tab, setTab] = useState('1');

  return (
    <Container>
      <NavTab
        tabs={[{ tab: 'ticketco' }, { tab: 'tickster' }]}
        setTab={setTab}
        activeTab={tab}
        queryName="ticketProvider"
        size="sm"
      />
      <TabContent activeTab={tab}>
        <TabPane tabId="1">
          {tab === '1' && (
            <ExternalTickets
              user={userID}
              phone={phoneNumber}
              provider="ticketco"
              isActive={tab === '1'}
            />
          )}
        </TabPane>
        <TabPane tabId="2">
          {tab === '2' && (
            <ExternalTickets
              user={userID}
              phone={phoneNumber}
              provider="tickster"
              isActive={tab === '2'}
            />
          )}
        </TabPane>
      </TabContent>
    </Container>
  );
};
export default UserTicketsPage;
